module.exports = __webpack_public_path__ + "4d71b916148bddb7185dbd7812ef7a3a.png";